import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/useAuth";

export default function OAuthCallback() {
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation("auth");
  useEffect(() => { checkAuth().then(() => navigate("/dashboard")); }, [checkAuth, navigate]);
  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <p className="text-[#A1A1AA]">{t("oauthCallback.loading")}</p>
    </div>
  );
}
